import type { ApiScopeCatalogItem } from '../../types';

// Filters the scope catalog by a free-text term and groups it by resource type (sorted by name).
export function groupScopeCatalog(
  scopeCatalog: ApiScopeCatalogItem[],
  searchTerm: string
): Array<[string, ApiScopeCatalogItem[]]> {
  const normalizedSearchTerm = searchTerm.trim().toLowerCase();
  const filtered = normalizedSearchTerm
    ? scopeCatalog.filter((item) =>
        [
          item.scope,
          item.name,
          item.description,
          item.resourceType,
          item.action,
          item.capabilityCode,
          ...(item.aliases ?? []),
        ]
          .filter(Boolean)
          .some((value) => String(value).toLowerCase().includes(normalizedSearchTerm))
      )
    : scopeCatalog;

  const groups = filtered.reduce<Record<string, ApiScopeCatalogItem[]>>((acc, item) => {
    const key = item.resourceType || 'other';
    acc[key] = [...(acc[key] ?? []), item];
    return acc;
  }, {});

  return Object.entries(groups).sort(([a], [b]) => a.localeCompare(b));
}
